package org.multiplatform.kotfolio.pages.kmm

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.core.Page
import org.multiplatform.kotfolio.components.KotlinCode
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties

@Page("/kmm/sandwich")
@Composable
fun Sandwich() {
    BlogLayout(
        PageProperties(
            "Sandwich",
            "Sandwich is an adaptable and lightweight sealed API library designed for handling API responses and exceptions in Kotlin for Retrofit, Ktor, and Kotlin Multiplatform."
        ),
        BlogProperties("Kotlin Multiplatform", "Sandwich")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            KotlinCode(
                code = """
                    sandwich = "2.2.0"
                    sandwich = { module = "com.github.skydoves:sandwich", version.ref = "sandwich" }
                    sandwich-ktor = { module = "com.github.skydoves:sandwich-ktor", version.ref = "sandwichRetrofit" }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    sealed class Result<out T> {
                        data class Success<out T>(val data: T) : Result<T>()
                        data class Error(val message: String?, val exception: Exception? = null) : Result<Nothing>()
                        data object Loading : Result<Nothing>()
                    }
                    
                    interface CoinRepository {
                        fun getAllCoins(): Flow<List<CoinEntity>>
                        suspend fun fetchAndStoreCoins(): ApiResponse<List<CoinRemoteModel>?>
                    }
                    
                    class GetCoinByIdUseCase constructor(
                        private val coinRepository: CoinRepository,
                    ) {
                        operator fun invoke(id: String): Flow<Result<CoinDetailUiModel?>> =
                            flow {
                                coinRepository.getCoinById(id)
                                    .suspendMapSuccess {
                                        this?.toUiModel()
                                    }
                                    .suspendOnSuccess {
                                        emit(Result.Success(data))
                                    }.suspendOnFailure {
                                        emit(Result.Error(message = message()))
                                    }

                            }.onStart {
                                emit(Result.Loading)
                            }
                    }
                    
                    class GetCoinListUseCases constructor(
                        private val coinRepository: CoinRepository,
                    ) {
                        operator fun invoke() = flow<Result<List<CoinUiModel>>> {
                            coinRepository.fetchAndStoreCoins()
                                .suspendMapSuccess {
                                    this?.map { it.toUiModel() }
                                }.suspendOnSuccess {
                                    val result: List<CoinUiModel>? = data
                                    emit(Result.Success(result ?: emptyList()))
                                }.suspendOnFailure {
                                    emit(Result.Error(message = message()))
                                }
                        }
                    }
                    """.trimIndent()
            )
        }
    }
}

//https://github.com/ocetin00/CryptoTrackerDesktop.git